import { Box } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

import type { ControllerDescription } from '@/features/controller/types'
import { useSiteQuery } from '@/features/site/hooks/useSiteQuery'

interface SiteForControllerProps {
  controller: ControllerDescription | null
}

export function SiteForController({ controller }: Readonly<SiteForControllerProps>) {
  const siteId = controller?.siteId
  const { site, isLoading: isLoadingSite } = useSiteQuery({ uuid: siteId }, { enabled: Boolean(siteId) })

  if (controller) {
    return isLoadingSite ? (
      <CircularProgress size={24} sx={{ verticalAlign: 'middle' }} title="Loading site" />
    ) : (
      site && (
        <Box>
          {site?.name} (<strong>{site?.countryCode}</strong>, <strong>{site?.location}</strong>)
        </Box>
      )
    )
  }
  return null
}
